<template>
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="HOME" name="1">
      <Home />
    </el-tab-pane>
    <el-tab-pane label="RESEARCH" name="2">
      <Research />
    </el-tab-pane>
    <el-tab-pane label="PUBLICATIONS" name="3">
      <Publication />
    </el-tab-pane>
    <el-tab-pane label="TEAM" name="4">
      <Team />
    </el-tab-pane>
    <el-tab-pane label="TEACHING" name="5">
      <Teaching />
    </el-tab-pane>
    <el-tab-pane label="RESOURCES" name="6">
      <Resources />
    </el-tab-pane>
    <el-tab-pane label="CONTACT" name="7">
      <Contact />
    </el-tab-pane>
  </el-tabs>
</template>
<script>
  import Home from './content/Home';
  import Research from './content/Research';
  import Publication from './content/Publication';
  import Team from './content/Team';
  import Teaching from './content/Teaching';
  import Resources from './content/Resources';
  import Contact from './content/Contact';

  export default {
    data() {
      return {
        activeName: '1'
      };
    },
    methods: {
      handleClick(tab, event) {
        this.activeName = tab.name;
      }
    },
    components: {
      Home,
      Research,
      Publication,
      Team,
      Teaching,
      Resources,
      Contact,
    }
  };
</script>

<style>
  .el-tab-pane{
    background-color: white;
  }
</style>


// WEBPACK FOOTER //
// src/components/TabContent.vue